import PropTypes from 'prop-types';

const ProjectMappingJiraProject = {
  id: PropTypes.number,
  key: PropTypes.string,
};

export default ProjectMappingJiraProject;
